import { indexTopics } from "@/mocks/homeContent";

const toneMap: Record<string, { chip: string; no: string }> = {
  primary: { chip: "bg-primary-100 text-primary-700", no: "text-primary-600" },
  accent: { chip: "bg-accent-100 text-accent-800", no: "text-accent-700" },
  secondary: { chip: "bg-secondary-100 text-secondary-800", no: "text-secondary-700" },
};

export default function IndexBoard() {
  return (
    <section id="index" className="w-full border-b border-background-200 bg-background-50">
      <div className="w-full px-4 py-12 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.34em] text-accent-700">Index · 索引与合集</p>
            <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              六个问题，一次看全
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            按困扰出现的频率排序，每个合集都只讲一件事，不绕弯。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-lg bg-background-200 sm:grid-cols-2 lg:grid-cols-3">
          {indexTopics.map((t) => {
            const tone = toneMap[t.tone] ?? toneMap.secondary;
            return (
              <a
                key={t.no}
                href="#timeline"
                className="group flex cursor-pointer flex-col bg-background-50 p-6 transition-colors hover:bg-background-100 md:p-7"
              >
                <div className="flex items-start justify-between gap-3">
                  <span className={`font-heading text-2xl font-bold ${tone.no}`}>{t.no}</span>
                  <span className={`rounded-full px-2.5 py-1 text-[11px] font-medium ${tone.chip}`}>
                    {t.question}
                  </span>
                </div>
                <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">{t.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{t.desc}</p>
                <span className="mt-6 flex items-center gap-1 text-xs font-medium text-foreground-500 transition-colors group-hover:text-primary-600">
                  查看合辑
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-line text-sm" />
                  </span>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}